/* Kerayong — homepage hero slider.
   Sticky-pinned, scroll-driven. Never intercepts scroll: no preventDefault on
   wheel/touch/key, no overflow:hidden on body. Finite. rAF runs only while the
   section is on screen. Vanilla JS, no dependencies, one IIFE, no globals. */
(function () {
  'use strict';

  // Guard against the section including this file more than once on a page.
  if (window.__kryHeroInit) return;
  window.__kryHeroInit = true;

  document.documentElement.classList.remove('no-js');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var instances = [];

  function svhPx() { return window.innerHeight / 100; }

  function init(section) {
    if (!section || section.__kryHero) return;
    var track = section.querySelector('.kry-hero__track');
    var pin = section.querySelector('.kry-hero__pin');
    var stage = section.querySelector('.kry-hero__stage');
    var imgs = Array.prototype.slice.call(section.querySelectorAll('.kry-hero__img'));
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('.kry-hero__thumb'));
    var thumbStrip = section.querySelector('.kry-hero__thumbs-strip');
    var metaStrip = section.querySelector('.kry-hero__meta-strip');
    var progress = section.querySelector('[data-kry-progress]');
    if (!track || !pin || !stage) return;

    var metaItems = Array.prototype.slice.call(section.querySelectorAll('.kry-hero__meta-item'));

    var slideCount = parseInt(section.getAttribute('data-slide-count'), 10) || imgs.length || 1;
    var parallaxOn = section.getAttribute('data-parallax') !== 'false';

    var state = {
      section: section, track: track, pin: pin, stage: stage, imgs: imgs,
      thumbs: thumbs, thumbStrip: thumbStrip, metaStrip: metaStrip, metaItems: metaItems, progress: progress,
      slideCount: slideCount, parallaxOn: parallaxOn,
      smoothed: 0, lastInt: -1, raf: 0, running: false,
      pinHeight: 0, thumbH: 0, metaItemH: 80, unit: 0
    };

    measure(state);

    // Thumb navigation — real buttons, native smooth scroll.
    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        var denom = (state.slideCount - 1) || 1;
        var top = track.offsetTop + (i / denom) * (track.offsetHeight - state.pinHeight);
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    // Start/stop the loop only while the section is on screen.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) start(state); else stop(state);
      });
    }, { rootMargin: '0px' });
    io.observe(section);
    state.io = io;

    section.__kryHero = state;
    instances.push(state);

    if (reduce.matches) { renderStatic(state); }
  }

  function measure(state) {
    state.pinHeight = state.pin.offsetHeight || window.innerHeight;
    if (state.thumbs.length > 1) {
      state.thumbH = state.thumbs[1].offsetTop - state.thumbs[0].offsetTop;
    } else if (state.thumbs.length) {
      state.thumbH = state.thumbs[0].offsetHeight + 12;
    }
    // Meta items can be taller than the 80px design box when a colourway name
    // wraps in the narrow minimap column. Size every item to the tallest one's
    // content (via a CSS var) and drive the strip by that real pitch, so no
    // slide's caption bleeds into the next. scrollHeight reads full content
    // height even while the box is clipped.
    if (state.metaItems && state.metaItems.length) {
      var h = 80;
      state.metaItems.forEach(function (it) { if (it.scrollHeight > h) h = it.scrollHeight; });
      state.metaItemH = h;
      state.section.style.setProperty('--kry-meta-h', h + 'px');
    }
    var mobile = window.innerWidth < 768;
    state.unit = (mobile ? 7 : 15) * svhPx();
  }

  function start(state) {
    if (state.running || reduce.matches) return;
    state.running = true;
    state.stage.style.willChange = 'transform';
    if (state.thumbStrip) state.thumbStrip.style.willChange = 'transform';
    if (state.metaStrip) state.metaStrip.style.willChange = 'transform';
    loop(state);
  }

  function stop(state) {
    state.running = false;
    if (state.raf) cancelAnimationFrame(state.raf);
    state.raf = 0;
    state.stage.style.willChange = 'auto';
    if (state.thumbStrip) state.thumbStrip.style.willChange = 'auto';
    if (state.metaStrip) state.metaStrip.style.willChange = 'auto';
  }

  function loop(state) {
    if (!state.running) return;
    var rect = state.track.getBoundingClientRect();
    var span = state.track.offsetHeight - state.pinHeight;
    var raw = span > 0 ? (-rect.top / span) : 0;
    var progressV = Math.max(0, Math.min(1, raw));
    var position = progressV * (state.slideCount - 1);

    var delta = position - state.smoothed;
    if (Math.abs(delta) >= 0.0005) {
      state.smoothed += delta * 0.09;
      write(state);
    }
    state.raf = requestAnimationFrame(function () { loop(state); });
  }

  function write(state) {
    var s = state.smoothed;
    state.stage.style.setProperty('--kry-pos', s.toFixed(4));

    if (state.parallaxOn) {
      for (var i = 0; i < state.imgs.length; i++) {
        var off = (s - i) * state.unit;
        if (off > state.unit) off = state.unit;
        else if (off < -state.unit) off = -state.unit;
        state.imgs[i].style.transform = 'translate3d(0,' + off.toFixed(2) + 'px,0)';
      }
    }

    if (state.thumbStrip && state.thumbH) {
      state.thumbStrip.style.transform = 'translate3d(0,' + (-s * state.thumbH).toFixed(2) + 'px,0)';
    }
    if (state.metaStrip) {
      state.metaStrip.style.transform = 'translate3d(0,' + (-s * state.metaItemH).toFixed(2) + 'px,0)';
    }

    var idx = Math.round(s);
    if (idx !== state.lastInt) {
      state.lastInt = idx;
      state.thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      if (state.progress) {
        var cur = ('0' + (idx + 1)).slice(-2);
        var tot = ('0' + state.slideCount).slice(-2);
        state.progress.innerHTML = '<b>' + cur + '</b> / ' + tot;
      }
    }
  }

  function renderStatic(state) {
    state.imgs.forEach(function (img) { img.style.transform = 'none'; });
    if (state.stage) state.stage.style.removeProperty('--kry-pos');
  }

  // Debounced resize + orientation
  var rt;
  function onResize() {
    clearTimeout(rt);
    rt = setTimeout(function () {
      instances.forEach(function (state) {
        measure(state);
        if (!reduce.matches) write(state);
      });
    }, 150);
  }
  window.addEventListener('resize', onResize, { passive: true });
  window.addEventListener('orientationchange', onResize, { passive: true });

  function destroy(section) {
    var state = section && section.__kryHero;
    if (!state) return;
    stop(state);
    if (state.io) state.io.disconnect();
    section.__kryHero = null;
    var idx = instances.indexOf(state);
    if (idx > -1) instances.splice(idx, 1);
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-kry-hero]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }

  // Theme editor lifecycle
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-kry-hero]');
    if (s) init(s);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var s = e.target.querySelector('[data-kry-hero]');
    if (s) destroy(s);
  });
  window.addEventListener('beforeunload', function () {
    instances.slice().forEach(function (state) { stop(state); });
  });

  reduce.addEventListener && reduce.addEventListener('change', function () {
    instances.forEach(function (state) {
      if (reduce.matches) { stop(state); renderStatic(state); }
      else start(state);
    });
  });
})();
